export default __webpack_public_path__ + "static/media/send.c0552cd1.svg";